import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😶',
  title: 'Las puertas se cierran',
  description: 'Tu hijo que antes corría a abrazarte ahora responde con monosílabos y actúa como si tu presencia fuera una interrupción.'
}, {
  emoji: '😤',
  title: 'Las discusiones no paran',
  description: 'Cada conversación termina en tensión. No sabes cómo hablar sin que explote, ni cómo mantener límites sin alejarle.'
}, {
  emoji: '😰',
  title: 'El miedo te paraliza',
  description: 'Redes sociales, malas influencias, drogas... No sabes cómo hablar de estos temas sin que tu hijo te cierre la puerta por completo.'
}, {
  emoji: '😔',
  title: 'Te sientes solo en esto',
  description: 'Nadie te enseñó a criar a un adolescente. No existe un manual. Y a veces sientes que lo estás haciendo todo mal.'
}, {
  emoji: '🤯',
  title: 'No entiendes sus reacciones',
  description: 'Sus emociones intensas, sus cambios de humor repentinos, su necesidad de alejarse... No sabes si es normal o si debes preocuparte.'
}, {
  emoji: '💔',
  title: 'Echas de menos al niño de antes',
  description: 'Sientes que perdiste a tu hijo. Que ya no te necesita. Y eso duele más de lo que nadie te dijo que iba a doler.'
}];
export function PainSection() {
  return <section className="bg-[#F0F4F0] py-20 px-5 text-center" data-id="element-190">
      <div className="max-w-5xl mx-auto" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-192">
          <div className="inline-block text-xs font-bold tracking-[3px] uppercase text-[#F4A535] mb-4" data-id="element-193">
            ¿Te suena familiar?
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#1A2744] max-w-2xl mx-auto mb-5 leading-tight" data-id="element-194">
            ¿Sientes que perdiste la conexión con tu hijo?
          </h2>

          <p className="text-lg text-[#4A5568] max-w-2xl mx-auto mb-12" data-id="element-195">
            No estás solo. Millones de padres viven exactamente esto cada día y
            no es su culpa.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto" data-id="element-196">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-7 text-left border-l-4 border-[#E53E3E] shadow-[0_4px_20px_rgba(0,0,0,0.06)]" data-id="element-197">
              <div className="text-4xl mb-3" data-id="element-198">{point.emoji}</div>
              <h3 className="text-base font-bold text-[#1A2744] mb-2" data-id="element-199">
                {point.title}
              </h3>
              <p className="text-sm text-[#718096]" data-id="element-200">{point.description}</p>
            </motion.div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mt-10" data-id="element-201">
          {[{
          src: 'https://cdn.magicpatterns.com/uploads/igsiiiaH7P5GFxxEQXqKhL/bajare.png',
          alt: 'Madre e hija conectando en el sofá'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/dBHuQh6jPRS8PmM9Q4DUSS/Bajares.png',
          alt: 'Madre acompañando a su hijo adolescente'
        }, {
          src: 'https://cdn.magicpatterns.com/uploads/badrTjyRbdXu8ErqTeQVTo/bajareso.png',
          alt: 'Adolescente y madre en momentos difíciles'
        }].map((img, index) => <motion.div key={`img-${index}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="overflow-hidden rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-202">
              <img src={img.src} alt={img.alt} className="w-full h-64 object-cover" data-id="element-203" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}